import { createContext } from 'react';

// Unified context for both cart and wishlist
export const ShopContext = createContext();